import React, {useState} from "react";
import Burger from '../Hamburger.js'
import MobileNavBar from '../MobileNavBar.js'
import '../Desktop.css'

import onea from '../../Images/Illustration/Capstone/11.jpg'
import oneb from '../../Images/Illustration/Capstone/1b.jpg'
import two from '../../Images/Illustration/Capstone/2.jpg'
import three from '../../Images/Illustration/Capstone/3.jpg'
import four from '../../Images/Illustration/Capstone/4.jpg'
import five from '../../Images/Illustration/Capstone/5.jpg'
import six from '../../Images/Illustration/Capstone/6.jpg'
import seven from '../../Images/Illustration/Capstone/7.jpg'
import eight from '../../Images/Illustration/Capstone/8.jpg'
import nine from '../../Images/Illustration/Capstone/9.jpg'
import ten from '../../Images/Illustration/Capstone/10.jpg'
import eleven from '../../Images/Illustration/Capstone/11.jpg'
import twelve from '../../Images/Illustration/Capstone/12.jpg'
import thirteen from '../../Images/Illustration/Capstone/13.jpg'
import fourteen from '../../Images/Illustration/Capstone/14.jpg'
import fifteen from '../../Images/Illustration/Capstone/15.jpg'
import sixteen from '../../Images/Illustration/Capstone/16.jpg'
import seventeen from '../../Images/Illustration/Capstone/17.jpg'
import eighteen from '../../Images/Illustration/Capstone/18.jpg'
import nineteena from '../../Images/Illustration/Capstone/19a.jpg'
import nineteenb from '../../Images/Illustration/Capstone/19b.jpg'
import twentya from '../../Images/Illustration/Capstone/20a.jpg'
import twentyb from '../../Images/Illustration/Capstone/20b.jpg'
import twentyonea from '../../Images/Illustration/Capstone/21a.jpg'
import twentyoneb from '../../Images/Illustration/Capstone/21b.jpg'
import twentytwoa from '../../Images/Illustration/Capstone/22a.jpg'
import twentytwob from '../../Images/Illustration/Capstone/22b.jpg'
import twentythree from '../../Images/Illustration/Capstone/23.jpg'
import twentythreea from '../../Images/Illustration/Capstone/23a.jpg'
import twentythreeb from '../../Images/Illustration/Capstone/23b.jpg'
import twentyfoura from '../../Images/Illustration/Capstone/24a.jpg'
import twentyfourb from '../../Images/Illustration/Capstone/24b.jpg'
import twentyfive from '../../Images/Illustration/Capstone/25.jpg'
import twentysix from '../../Images/Illustration/Capstone/26.jpg'

function Emperor(){
	const [open, setOpen] = useState(false);

    return(
    	<div class="page">
			<div className="mobileNav">
				<Burger open={open} setOpen={setOpen}/>
				<MobileNavBar open={open} setOpen={setOpen}/>
			</div>
		    <div class="illustrationContentPage">
		        <h2>Honesty, Devotion, Benevolence</h2>
		        <p class="contentText">For my Senior Thesis, I created an illustrated children’s book with an educational purpose. The theme is similar to Aesop’s fables familiar to children in Western culture, however, I wanted to make this project personal and relevant to the culture and values I grew up with in Taiwan. The three stories each represent one of the main value systems in Confucianism, which are‬ benevolence, devotion, and honesty. I love these stories because they remind of my childhood and taught me fundamental moral values at a young age. They were crucial to my character development, and I am grateful to share them with children around the world.</p>
		        <div class="row">
		            <div class="column">
		                <img class="contentImage" src={onea} />
		            </div>
		            <div class="column">
		                <img class="contentImage" src={oneb} />
		            </div>
		        </div>
		        <img class="contentImage" src={two} />
		        <p class="contentText">Hand-bound final product - hard cover with perfect binding method</p>
		        <img class="contentImage" src={three} />
		        <p class="contentText">Each story ends with a bilingual definition page divided by a hand-pressed red texture paper</p>
		        <img class="contentImage" src={four} />
		        <p class="contentText">opening spread for the story "The Emperor's seeds"</p>
		        <img class="contentImage" src={five} />
		        <p class="contentText">close up</p>
		        <img class="contentImage" src={six} />
		        <p class="contentText">opening spread for the story "Ban Pin Shan"</p>
		        <img class="contentImage" src={seven} 	/>
		        <img class="contentImage" src={eight} />
		        <img class="contentImage" src={nine} />
		        <p class="contentText">opening scene of the story "The Carp Cure"</p>
		        <img class="contentImage" src={ten} />
		        <img class="contentImage" src={eleven} />
		        <img class="contentImage" src={twelve} />
		        <img class="contentImage" src={thirteen} />
		        <img class="contentImage" src={fourteen} />
		        <img class="contentImage" src={fifteen} />
		        <img class="contentImage" src={sixteen} />
		        <img class="contentImage" src={seventeen} />
		        <img class="contentImage" src={eighteen} />
		        <img class="contentImage" src={nineteena} />
		        <img class="contentImage" src={nineteenb} />
		        <img class="contentImage" src={twentya} />
		        <img class="contentImage" src={twentyb} />
		        <img class="contentImage" src={twentyonea} />
		        <img class="contentImage" src={twentyoneb} />
		        <img class="contentImage" src={twentytwoa} />
		        <img class="contentImage" src={twentytwob} />
		        <img class="contentImage" src={twentythree} />
		        <img class="contentImage" src={twentythreea} />
		        <img class="contentImage" src={twentythreeb} />
		        <img class="contentImage" src={twentyfoura} />
		        <img class="contentImage" src={twentyfourb} />
		        <img class="contentImage" src={twentyfive} />
		        <img class="contentImage" src={twentysix} />		       
		    </div>
		</div>
    )
}

export default Emperor